import { ShuffleDto } from "../../dto/shuffle/shufflesdto";
import { APIRequest, APIRequestDtoImpl } from "../apiRequest";

export interface ShuffleRequest extends APIRequest
{
    getShuffleRequest(): ShuffleDto;
}

export class ShuffleRequestImpl extends APIRequestDtoImpl implements ShuffleRequest
{
    constructor(private shuffleData: ShuffleDto)
    {
        super();
    }

    getShuffleRequest(): ShuffleDto
    {
        return this.shuffleData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/shuffle/shufflerequest.ts